// SharedComponents/Layout.jsx
import { Outlet } from "react-router-dom";
import Breadcrumb from "./BreadCrumb";

const Layout = () => {
  return (
    <div className="">
      <Breadcrumb />
      <Outlet />
    </div>
  );
};

export default Layout;
